
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { BrandColourNames, BrandColoursType, } from '~/utils/resources';

@Component
export default class Spinner extends Vue {

	@Prop({
		type: String,
		required: false,
		validator(value) {
			return typeof value === 'string' && (BrandColourNames as string[]).includes(value);
		},
	})
	colour!: BrandColoursType;

	@Prop({
		type: Boolean,
		required: false,
		default: true,
	})
	fullScreen!: boolean;
}

